"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2UserLoginRefresh = void 0;
exports.v2UserLoginRefreshSetMock = v2UserLoginRefreshSetMock;
exports.v2UserLoginRefresh = v2UserLoginRefresh;
exports.useMutationV2UserLoginRefresh = useMutationV2UserLoginRefresh;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2UserLoginRefreshSetMock(mock) {
    setMock = mock;
}
async function v2UserLoginRefresh(body, params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(body, params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v2/login/refresh`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { data: body, headers, method: 'POST', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2UserLoginRefresh = 'cockatoo:v2UserLoginRefresh:post';
function useMutationV2UserLoginRefresh(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyV2UserLoginRefresh }, mutationOptions));
}
function mutationFn({ body, params }) {
    const promise = v2UserLoginRefresh(body, params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-user-login-refresh.js.map